module.exports = __webpack_public_path__ + "static/media/PetMatchScreen.0a3c031f.png";